import React from 'react'
import EyefinityModuleSelect from './EyefinityModuleSelect'
import EyefinityDynamicForm from './EyefinityDynamicForm'
import EyefinityServiceSection from './EyefinityServiceSection'
import { useDispatch } from 'react-redux'
import { visionInsuranceClaimFormUpdate, visionInsuranceClaimFormEdit } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'
import { withOrdersInsuranceId } from '../../../../../../../../../components/authorised/order/claimFormDropdownUtils'
import { getClaimSectionsForPayload } from './eyefinityServiceSections'

const SERVICE_CONDITION_KEYS = [
  'high_risk_for_prediabetes',
  'diabetes',
  'hypertension',
  'high_cholesterol',
  'diabetic_retinopathy',
  'glaucoma',
  'amd',
  'none',
]

const buildServicePayload = (service = {}) => {
  const serviceConditionPayload = SERVICE_CONDITION_KEYS.reduce((payload, key) => ({
    ...payload,
    [key]: !!service[key],
  }), {})

  const serviceLines = (service.service_lines || [])
    .slice(0, 3)
    .map((line = {}) => ({
      emg: !!line.emg,
      proc: line.proc,
      modifier: line.modifier,
      diagnosis_pointers: (line.diagnosis_pointers || []).filter(Boolean),
      charges: line.charges,
      unit_count: line.unit_count,
      epsdt: !!line.epsdt,
    }))
    .filter(line => (
      line.proc ||
      line.modifier ||
      line.diagnosis_pointers.length ||
      line.charges ||
      line.unit_count ||
      line.emg ||
      line.epsdt
    ))

  return {
    pcp_communication_completed_planned: service.pcp_communication_completed_planned,
    ...serviceConditionPayload,
    diagnosis: (service.diagnosis || []).filter(Boolean),
    service_lines: serviceLines,
    patient_paid: service.patient_paid,
  }
}

const buildPage2Payload = (data = {}) => ({
  ...data,
  service: buildServicePayload(data.service),
})

export default function EyefinityStepForm(props) {
  const { pprops: { visionInsuranceClaimForm, claimFormTemplate, saving, orderStoreId, editing, editing: { activeTab }, formValues, invalid, firstStepActionLabel } } = props
  const dispatch = useDispatch()
  const storeId = Number(localStorage.getItem('StoreID')) ?? ''

  const getClaimSections = (data) => getClaimSectionsForPayload(data?.eligibility?.data)
  const getPage1Payload = (data = {}) => {
    const claimSections = getClaimSections(data)

    return {
      ...data,
      claim_sections: claimSections.length
        ? [...claimSections, 'service_line']
        : claimSections,
    }
  }

  const handlePage1Back = () => {
    dispatch(visionInsuranceClaimFormEdit({ activeTab: 'first' }))
  }

  const handlePage2Back = () => {
    dispatch(visionInsuranceClaimFormEdit({ activeTab: 2 }))
  }

  const handlePage1Next = (data) => {
    const claimSections = getClaimSections(data)
    dispatch(visionInsuranceClaimFormUpdate(
      { ...getPage1Payload(data) },
      withOrdersInsuranceId(
        { requires_eyefinity_calculation: true, claim_sections: [...claimSections, 'service_line'] },
        editing.orders_insurance_id,
      ),
    ))
    dispatch(
      visionInsuranceClaimFormEdit({
        activeTab: 3
      })
    )
  }
  const handlePage2Save = (data) => {
    dispatch(visionInsuranceClaimFormUpdate(
      buildPage2Payload(data),
      withOrdersInsuranceId({ ...storeId, claim_sections: ['service'] }, editing.orders_insurance_id),
    ))
    // dispatch(
    //   visionInsuranceClaimFormEdit({
    //     activeTab: 'final'
    //   })
    // )
  }

  return (
    <div className='mt-7'>
      {activeTab === 'first' && <EyefinityModuleSelect visionInsuranceClaimForm={visionInsuranceClaimForm} actionLabel={firstStepActionLabel} />}
      {activeTab === 2 && (
        <>
          <EyefinityDynamicForm
            page="page1"
            claimFormTemplate={claimFormTemplate}
            formValues={formValues}
          />

          <div className="d-flex justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-outline-primary mr-5 px-7"
              onClick={handlePage1Back}
            >
              Back
            </button>
            <button
              type="button"
              className="btn btn-primary px-7"
              disabled={invalid || saving}
              onClick={() => handlePage1Next(formValues)}
            >
              Next
            </button>
          </div>
        </>
      )}

      {activeTab === 3 && (
        <>
          <EyefinityDynamicForm
            page="page2"
            claimFormTemplate={claimFormTemplate}
            formValues={formValues}
          />

          <EyefinityServiceSection />

          <div className="d-flex justify-content-end mt-4">
            <button
              type="button"
              className="btn btn-outline-primary mr-5 px-7"
              onClick={handlePage2Back}
            >
              Back
            </button>
            <button
              type="button"
              className="btn btn-primary"
              disabled={saving}
              onClick={() => handlePage2Save(formValues)}
            >
              Save
            </button>
          </div>
        </>
      )}
      {/* {activeTab === 'final' && <EyefinityFinalStep saving={saving} editing={editing} visionInsuranceClaimForm={visionInsuranceClaimForm} />} */}
    </div>
  )
}
